import React, { useState, useEffect } from "react";
import {
  DialogTitle,
  DialogContent,
  DialogActions,
  Typography,
  IconButton,
  TextField,
  Button,
  Rating,
  FormHelperText,
} from "@mui/material";
import Grid from "@mui/material/Grid2";
import CloseIcon from "@mui/icons-material/Close";
import BootstrapDialog from "@mui/material/Dialog"; // or your customized Dialog
import { toast } from "react-toastify";

const ReviewDialog = ({
  openDialog,
  handleClose,
  handleSubmitReview,
  title,
  reviewData,
  isViewMode,
}) => {
  const [rating, setRating] = useState(0);
  const [description, setDescription] = useState("");

  useEffect(() => {
    if (openDialog) {
      if (reviewData) {
        // console.log(reviewData);
        
        setRating(reviewData.rating || 0);
        setDescription(reviewData.comment || "");
      } else {
        setRating(0);
        setDescription("");
      }
    }
  }, [openDialog, reviewData]);

  const handleChange = (e) => {
    const value = e.target.value;
    if (value.length <= 130) {
      setDescription(value);
    }
  };

  const handleSubmit = () => {
    if (!rating) {
      toast.error("Rating is required.");
      return;
    }
    if (!description.trim()) {
      toast.error("Description is required.");
      return; // Don't proceed
    }
    handleSubmitReview({ rating, description });
    handleClose();
  };

  return (
    <BootstrapDialog
      onClose={handleClose}
      aria-labelledby="customized-dialog-title"
      open={openDialog}
      className="admin-admins"
    >
      <DialogTitle sx={{ m: 0, p: 2 }} id="customized-dialog-title">
        {isViewMode === true ? "Your review" : "write a review"}
        <Typography variant="body2" sx={{ mt: 1 }}>
          {isViewMode === true
            ? "Your shared feedback"
            : "Share your feedback about your experience"}
        </Typography>
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>

      <DialogContent dividers>
        <section>
          <Grid container spacing={3}>
            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="admin-textfiled">
                <Typography component="legend" sx={{ mb: 1 }}>
                  Rating
                </Typography>
                <Rating
                  name="rating"
                  value={rating}
                  precision={0.5}
                  onChange={(event, newValue) => {
                    if(!isViewMode === true) setRating(newValue);
                  }}
                  readOnly={isViewMode === true}
                />
              </div>
            </Grid>

            <Grid item size={{ xs: 12, sm: 12, md: 12, lg: 12 }}>
              <div className="admin-textfiled">
                <TextField
                  label="Review Comment"
                  multiline
                  rows={4}
                  fullWidth
                  value={description}
                  placeholder="Write your thoughts here..."
                  onChange={handleChange}
                  disabled={isViewMode === true}
                />
                <FormHelperText sx={{ textAlign: "right" }}>
                  {description.length}/130
                </FormHelperText>
              </div>
            </Grid>
          </Grid>
        </section>
      </DialogContent>

      <DialogActions>
        {isViewMode === true ? null : (
          <>
            <Button className="cancel-btn" onClick={handleClose}>
              Cancel
            </Button>
            <Button className="add-btn" onClick={handleSubmit}>
              Submit
            </Button>
          </>
        )}
      </DialogActions>
    </BootstrapDialog>
  );
};

export default ReviewDialog;
